module.exports = __webpack_public_path__ + "img/upload_processing.dccb6a33.gif";